import React from "react";
import CustomerTable from "./components/CustomerTable";
import { useClient } from "Context/Client";

export function Endcustomers() {
  const { client } = useClient();

  return (
    <>
      <CustomerTable customers={client.EndCustomers} />
    </>
  );
}
